import { PropsWithChildren, useMemo, useState } from 'react';
import { AppContext, appContextInitialValue } from './AppContext';
import {
  useFsEnvIdQueryParam,
  useFsUrlQueryParam,
  usePlatformQueryParam,
  useTagOAuthCodeV1QueryParam,
  useTagUrlQueryParam,
} from '../hooks';
import { AppContextState } from '../type';

export function AppProvider({ children }: PropsWithChildren) {
  const platformTypeParam = usePlatformQueryParam();
  const fsUrl = useFsUrlQueryParam();
  const tagUrl = useTagUrlQueryParam();
  const fsEnvId = useFsEnvIdQueryParam();
  const tagOAuthCodeV1 = useTagOAuthCodeV1QueryParam();

  const [state, setState] = useState<AppContextState>({
    ...appContextInitialValue.state,
    platformType: platformTypeParam,
    fsUrl,
    tagUrl,
    fsEnvId,
    tagOAuthCodeV1,
  });

  const appContextValueMemo = useMemo(() => ({ state, setState }), [state]);

  return <AppContext.Provider value={appContextValueMemo}>{children}</AppContext.Provider>;
}
